/**
 * Finds the flavor from the closest flavor-context parent and tries to match it against a list of supported flavors.
 * If no match, returns the first supported flavor, which is understood to be the "core" for that component.
 */
function getFlavor(host, flavors) {
  var _a, _b;
  const flavor = (_a = host.closest('tt-flavor-context')) === null || _a === void 0 ? void 0 : _a.getAttribute('flavor');
  return (_b = flavors.find((t) => t === flavor)) !== null && _b !== void 0 ? _b : flavors[0];
}

export { getFlavor as g };
